import { Injectable } from '@angular/core';
import { HttpService } from '../http/http.service';

@Injectable({
  providedIn: 'root'
})
export class FiltersService {

  constructor(private http: HttpService) { }

  getList(id_store:string){
    return this.http.get(`filters/${id_store}/list`)
  }

}
